import styled from '@emotion/styled'

import { palette, spacing, Strong } from 'main/ui'

export const ContentContainer = styled.div`
  align-items: center;
  display: flex;
`

export const LabelStrong = styled(Strong)`
  color: ${palette.white};
  margin-left: ${spacing.majorScale(2)}px;
`
